import { render, staticRenderFns } from "./TraxUiStructItemForm.vue?vue&type=template&id=23cf4b9f"
import script from "./TraxUiStructItemForm.vue?vue&type=script&lang=js"
export * from "./TraxUiStructItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports